<template>
  <form class="plp-accessories-purchase-form" @submit.prevent="submit">
    <div
      role="group"
      class="quantity-selector-incremental"
      data-qty-incremental
    >
      <button type="button" @click="updateQuantity(-1)">-</button>
      <input disabled type="text" :value="quantity" />
      <button type="button" @click="updateQuantity(1)">+</button>
    </div>

    <button
      class="button button-outline-brand plp-purchase-form-submit"
      :class="{ 'button-disabled': isOutOfStock }"
      type="submit"
    >
      {{ addToCartText }}
    </button>
    <p v-if="isOutOfStock" class="plp-accessories-purchase-form-error-message">
      {{ notEnoughStockText }}
    </p>
  </form>
</template>

<script>
import * as ShopifyCart from '@shopify/theme-cart';
export default {
  props: {
    addToCartText: {
      type: String,
      default: 'Add to Cart**'
    },
    notEnoughStockText: {
      type: String,
      default: 'Not enough stock**'
    },
    productId: {
      type: Number,
      default: 0
    },
    inventoryQuantity: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      quantity: 1,
      isOutOfStock: false
    };
  },

  mounted() {
    if (this.inventoryQuantity < 1) {
      this.isOutOfStock = true;
      this.quantity = 0;
    }

    this.$globalEventBus.addListener(
      'flyoutCart.removeItem',
      this.clearNotEnoughStockOnRemoveFromCart
    );
  },

  methods: {
    submit() {
      ShopifyCart.addItem(this.productId, {
        quantity: this.quantity,
        properties: {}
      })
        .then(() => {
          this.$globalEventBus.emit('flyoutCart.addItem');
        })
        .catch(error => {
          if (error.status === 422) {
            this.isOutOfStock = true;
          }
          console.error(error);
        });
    },
    updateQuantity(increment) {
      const currentQuantity = this.quantity;
      const newQuantity = currentQuantity + increment;

      if (newQuantity < 0) return;
      if (newQuantity > this.inventoryQuantity) return;
      if (newQuantity < currentQuantity) {
        this.isOutOfStock = false;
      }

      this.quantity = newQuantity;
    },
    clearNotEnoughStockOnRemoveFromCart(item) {
      if (this.productId === item.id) {
        this.isOutOfStock = false;
      }
    }
  }
};
</script>
